import { useState } from 'react';
import { AccordionGroup, Accordion } from 'palette/Accordion';
import { Header, type TagName } from 'palette/Typography';
import { BEMBlock } from '@helpers/classnames';

import './ListingFaq.scss';

type ListingFaqProps = {
    faqs: Array<{ answer: string; question: string }>;
    faqTitleHeadingTag: TagName;
    faqQuestionHeadingTag: TagName;
};

export function ListingFaq({
    faqs,
    faqTitleHeadingTag = 'h3',
    faqQuestionHeadingTag = 'h4',
}: ListingFaqProps) {
    const [visibleAccordionElements, setVisibleAccordionElements] = useState<string[]>([]);

    const [block, element] = BEMBlock('listing-faq');

    return (
        <div className={block}>
            <div className={element('header-box')}>
                <Header
                    color="strong"
                    level="5"
                    tagName={faqTitleHeadingTag}
                >
                    FAQ
                </Header>
            </div>
            <AccordionGroup
                allowMultipleExpanded
                className={element('accordion')}
                value={visibleAccordionElements}
                onChange={setVisibleAccordionElements}
            >
                {
                    faqs.map(({ question, answer }) => (
                        <Accordion
                            key={`${question}${answer}`}
                            divider={!visibleAccordionElements.includes(question)}
                            label={question}
                            tagName={faqQuestionHeadingTag}
                            unmountOnHide={false}
                            weight="bold"
                        >
                            <div dangerouslySetInnerHTML={{ __html: answer }} />
                        </Accordion>
                    ))
                }
            </AccordionGroup>
        </div>
    );
}
